export default __webpack_public_path__ + "static/ibis-hotels-f264af35888276fa1e9f74c4f6821089.svg";